// client/src/services/transactionService.js
import api from './api';

// Get all transactions
export const getTransactions = async () => {
  const response = await api.get('/transactions');
  return response.data;
};

// Get transactions for a specific category
export const getTransactionsByCategory = async (categoryId) => {
  const response = await api.get(`/transactions/category/${categoryId}`);
  return response.data;
};

// Create a new transaction
export const createTransaction = async (transactionData) => {
  const response = await api.post('/transactions', transactionData);
  return response.data;
};

// Update a transaction
export const updateTransaction = async (id, transactionData) => {
  const response = await api.put(`/transactions/${id}`, transactionData);
  return response.data;
};

// Delete a transaction
export const deleteTransaction = async (id) => {
  const response = await api.delete(`/transactions/${id}`);
  return response.data;
};